import { MouseEvent } from 'react';

export const smoothScrollTo = (selector: string) =>
  document.querySelector(selector)?.scrollIntoView({
    behavior: 'smooth',
  });

export const handleScrollToTarget = (e: MouseEvent<HTMLAnchorElement>) => {
  const selector = (e.target as HTMLAnchorElement).getAttribute('href');

  if (selector && selector.indexOf('#') === 0) {
    e.preventDefault();
    e.stopPropagation();

    smoothScrollTo(selector);
  }
};
